import { useGetIntegrationDataQuery } from '../api/integrations/factorial';
import { selectCompany } from 'src/old/actions/company/companySelectors';
import { useAppSelector } from 'src/store';

export const useHasIntegration = (skip = false) => {
  const { data: integrationData } = useGetIntegrationDataQuery(undefined, { skip });
  const companyData = useAppSelector(selectCompany);

  const hasIntegration = Boolean(
    companyData?.integrationType ?? integrationData?.some(subsidiary => subsidiary?.flowsEnabled?.general)
  );

  return hasIntegration;
};
